import { useMutation, useQueryClient } from '@tanstack/react-query'

import { queryKeys } from '@/shared/hooks/queries/queryKeys'
import { submitReading } from '../../apis/prescriptionReading'
import { type PrescriptionReadingResponse } from '../../types'
import { type ParsedReading } from '../queries/usePrescriptionReadingQuery'

interface Variables {
  yakurekiId: string
  reading: string
}

// 提出直後の processing。GET refetch の到着を待たず即時反映する。
const PROCESSING: ParsedReading = {
  status: 'processing',
  data: null,
  errorMessage: null,
}

// 自分の読みを提出して AI 講評の生成を起こす。成功後は cache を即 processing に載せ替え、
// 入力フォームの再表示（=二重送信）と旧講評のちらつきを防いだうえで invalidate してポーリングへ。
export const useSubmitReadingMutation = () => {
  const queryClient = useQueryClient()

  return useMutation<PrescriptionReadingResponse, unknown, Variables>({
    mutationFn: async ({ yakurekiId, reading }) => {
      const res = await submitReading(yakurekiId, reading)
      return res.data
    },
    onSuccess: (_data, { yakurekiId }) => {
      const key = queryKeys.prescriptionReading.detail(yakurekiId)
      queryClient.setQueryData<ParsedReading>(key, PROCESSING)
      queryClient.invalidateQueries({ queryKey: key })
    },
  })
}
